import { Stack } from "@fluentui/react";
import React from "react";
import { Icon } from "../../../../Icon/Icon";
import { Text } from "../../../../Text/Text";
import { errorTextStyles } from "./DrawerHeaderError.styles";

export interface DrawerHeaderErrorProps {
    readonly errorMessage: string;

    /**
     * Id to link with Drawer content
     */
    readonly id?: string;
}

export const DrawerHeaderError: React.FC<DrawerHeaderErrorProps> = ({
    errorMessage,
    id
}) => {

    return (
        <Stack horizontal={true} horizontalAlign="start" verticalAlign="center">
            <Stack verticalAlign="center" tokens={{ padding: "0px 16px 0px 0px" }}>
                <Icon iconName="Error" size="16px" color="errorIcon" />
            </Stack>
            <Stack verticalAlign="center" styles={errorTextStyles()}>
                <Text block={true} nowrap={true} colorOverride="error" variant="bodyPrimaryText" id={id}>{errorMessage}</Text>
            </Stack>
        </Stack>
    );
};
